import { render, staticRenderFns } from "./ChangeTournamentMatchForms.vue?vue&type=template&id=159afc8c&scoped=true"
import script from "./ChangeTournamentMatchForms.vue?vue&type=script&lang=js"
export * from "./ChangeTournamentMatchForms.vue?vue&type=script&lang=js"
import style0 from "./ChangeTournamentMatchForms.vue?vue&type=style&index=0&id=159afc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159afc8c",
  null
  
)

export default component.exports